import React from "react";

const ArrowUpDownIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>arrow-up-down-icon</title>
      <path
        d="M10.29 11.27c.186-.19.44-.297.706-.297.265 0 .52.106.706.296.39.396.39 1.034 0 1.43l-2.644 2.852c-.28.284-.662.444-1.06.444-.4 0-.78-.16-1.06-.444l-2.645-2.85c-.39-.398-.39-1.036 0-1.433.186-.19.44-.297.707-.297.265 0 .52.106.706.296l1.29 1.477V3.25l-1.29 1.478c-.186.19-.44.296-.706.296-.266 0-.52-.107-.707-.296-.39-.398-.39-1.036 0-1.433L6.938.445C7.218.16 7.598 0 7.998 0c.398 0 .78.16 1.06.444L11.7 3.302c.392.397.392 1.035 0 1.433-.185.19-.44.296-.705.296-.266 0-.52-.106-.707-.295l-1.293-1.48v9.503l1.294-1.49z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ArrowUpDownIcon;
